/**
 * Result type for operations that may fail.
 *
 * Discriminated union representing success (with value) or failure (with error).
 * Maps to Rust's Result<T, String>.
 *
 * @example
 * ```ts
 * const success: Result<number> = { value: 42, error: undefined }
 * const failure: Result<number> = { value: undefined, error: new Error("failed") }
 * ```
 */
export type Result<T> =
  | {
      error: Error
      value: undefined
    }
  | {
      error: undefined
      value: T
    }
